import { ComponentPropsWithoutRef, FC } from 'react'

export const Label: FC<ComponentPropsWithoutRef<'label'>> = props => {
  return (
    <label
      className='text-right'
      style={{ display: 'inline-block', width: '100%' }}
      {...props}
    />
  )
}

export const BigLabel: FC<ComponentPropsWithoutRef<'label'>> = props => {
  return (
    <label
      className=' h5'
      style={{ display: 'inline-block', width: '100%' }}
      {...props}
    />
  )
}
